// @ts-nocheck
/**
 * The Coal River Wine Hopper — operated by our sister company, The Wine Hopper.
 *
 * This product lives in a SEPARATE Rezdy account (thewinehoppertasmania.rezdy.com),
 * so it is not returned by the Tassie Tours Rezdy API and never appears in
 * allTours.json. Because allTours.json is regenerated from the API on every build
 * (see src/lib/utils/buildTourData.cjs), the product has to be declared here by
 * hand — anything added to allTours.json would be wiped on the next build.
 *
 * The shape below deliberately mirrors a Rezdy tour object so it can be handed
 * straight to <TourCard /> alongside the real day tours.
 */
export const coalRiverWineHopper = {
	productCode: 'WHCRWH',
	name: 'Coal River Wine Hopper',
	productType: 'DAYTOUR',
	advertisedPrice: 99,
	durationMinutes: 420,
	shortDescription:
		"Tasmania's only hop-on hop-off wine tour. Explore seven premier locations in the Coal River Valley — including Coal Valley Vineyard, Riversdale Estate and Pooley Wines — at your own pace, with hourly pickups all day.",
	images: [{ itemUrl: '/src/lib/assets/enhanced/coal-river-wine-hopper.jpg' }],
	locationAddress: { city: 'Hobart', state: 'TAS' }
};

/** Numeric Rezdy widget ID, read from the product's booking URL. */
const WINE_HOPPER_REZDY_ID = 676555;

const WINE_HOPPER_REZDY_BASE = 'https://thewinehoppertasmania.rezdy.com';

/** Iframe src for the inline calendar booking widget. */
export const wineHopperCalendarLink = `${WINE_HOPPER_REZDY_BASE}/calendarWidget/${WINE_HOPPER_REZDY_ID}?iframe=true`;

/** Public Rezdy booking page, used as the no-JS/fallback booking link. */
export const wineHopperBookingLink = `${WINE_HOPPER_REZDY_BASE}/${WINE_HOPPER_REZDY_ID}/coal-river-valley-region`;

/** The Wine Hopper's own page for this product. */
export const wineHopperSiteLink = 'https://thewinehopper.com/coal-river-wine-hopper';
